import React from 'react'
import useProjects from '../../hooks/useProjects';
import ProjectCard from '../Atoms/ProjectCard';
import ProjectCardHome from '../Atoms/ProjectCardHome';
function DashboardLayout({ token, handleSelectedRecentProject }) {

  const { projects } = useProjects(token);

  const videoList = [
    {
      title: 'How to create a project',
      url: 'https://www.youtube.com/watch?v=xtvhCKVyL44',
      thumbnail: 'https://img.youtube.com/vi/xtvhCKVyL44/hqdefault.jpg'
    },
    {
      title: 'Edit, Remove & Download Your Framework',
      url: 'https://www.youtube.com/watch?v=OOG5vc3Z5Yo',
      thumbnail: 'https://img.youtube.com/vi/OOG5vc3Z5Yo/hqdefault.jpg'
    },
    {
      title: 'Build Your Project Framework',
      url: 'https://www.youtube.com/watch?v=nQzy2pk_Zf8',
      thumbnail: 'https://img.youtube.com/vi/nQzy2pk_Zf8/hqdefault.jpg'
    },
    {
      title: 'Create WBS',
      url: 'https://www.youtube.com/watch?v=zwhkgZxkBXY',
      thumbnail: 'https://img.youtube.com/vi/zwhkgZxkBXY/hqdefault.jpg'
    }
  ]

  const totalProjects = projects.filter(project => !project.is_template);

  return (
    <div className='row mt-5'>
      <div className='col-12'>
        <h5>Recent Projects</h5>
        <div className='d-flex flex-column flex-md-column' >
          <div className='mt-3 w-100 p-2'>
            {totalProjects.length > 0 ? (              
              totalProjects.map((project, index) => (
                // <div key={index} className="container-project-item" onClick={() => { handleSelectedRecentProject(project,false) }}>
                <div key={index} className="text-left mb-3">
                  {/* <ProjectCard
                    {...project}
                    editable={false}
                  /> */}
                  <ProjectCardHome
                    {...project}
                    project={project}
                    editable={false}
                    handleSelectedRecentProject={handleSelectedRecentProject}
                  />
                </div>
              ))
            ) : (
              <p>You don't have any projects created yet. <span style={{color:'blue', fontStyle:'italic', textDecoration:'underline', cursor:'pointer'}} onClick={()=>{handleSelectedRecentProject(null,true)}}>Start a new one</span></p>
            )}
          </div>
        </div>
      </div>
      {/* <div className='col-0 col-md- offset-md-1"'>

      </div> */}
      <div className='mt-5 mt-md-0 col-12 col-md-12 d-none'>
        {/* <a href='https://www.youtube.com/@ConstructionConnections' target='_blank'>
          <div className='d-flex flex-column flex-md-row p-3 discover-panel'>
          <div><h3 className='discover-title text-dark'>Get Starter with 'Quick start' video tutorials</h3></div>
          <div className='discover-image'><img src={'https://d1ih8jugeo2m5m.cloudfront.net/2024/12/cuanto_paga_youtube.webp'} width={300}></img></div>
          </div>
          </a> */}
          <h5>Discover</h5>
        <div className='row justify-content-left p-3 '>
          {videoList.map((video, index) => (
            <div key={index} className={`border-bottom mb-4 d-flex p-2 col-12 col-md-5 ${index % 2 !== 0?"offset-md-1":""}`} style={{backgroundColor:'white'}}>
              <div className="row">
                <div className='col-4'>
                <a href={video.url} target="_blank">
                  <img src={video.thumbnail} className="" alt={video.title}  />
                </a>
                </div>
                <div className="col-8 px-2">
                  <h5 className="" style={{fontSize:'18px'}}>{video.title}</h5>
                  <a href={video.url} target="_blank" style={{color:'#1a67a3'}}><i class="bi bi-play-fill" ></i> Play</a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div >
    </div>
  )
}

export default DashboardLayout
